import { ReactComponent as EventHost } from "../../assets/HelpCenter/Event_Host2.svg";
import { ReactComponent as Performer } from "../../assets/HelpCenter/Performer2.svg";
import { ReactComponent as Crew } from "../../assets/HelpCenter/Crew2.svg";
import { ReactComponent as Planner } from "../../assets/HelpCenter/Planner2.svg";
import { useNavigate } from "react-router-dom";
function ArrowRight() {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-3.5 h-3.5"
    >
      <path d="M3 8h10M9 4l4 4-4 4" />
    </svg>
  );
}

const ThumbsUp = ({ count }) => (
  <div className="flex items-center gap-1 text-gray-400 text-sm">
    <span>{count}</span>
    <svg
      className="w-4 h-4"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21H5a2 2 0 01-2-2v-7a2 2 0 012-2h2.924M14 10V5a2 2 0 00-2-2h-1l-3 7v9"
      />
    </svg>
  </div>
);

function roleToIcon(role) {
  if (role === "Event Host") return <EventHost className="w-7 h-7" />;
  if (role === "Planner") return <Planner className="w-7 h-7" />;
  if (role === "Performer") return <Performer className="w-7 h-7" />;
  if (role === "Crew") return <Crew className="w-7 h-7" />;
  return null;
}

function truncateDescription(desc, len) {
  if (desc.length <= len) return desc;
  return desc.slice(0, len) + "...";
}

export const ArticleCard = ({ article, len = 100 }) => {
  const navigate = useNavigate();

  const handleArticleClick = () => {
    navigate(`/help/${article._id}`);
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5 flex flex-col gap-2 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        {roleToIcon(article?.role)}
        <ThumbsUp count={article?.likes} />
      </div>
      <h4 className="font-semibold text-gray-900 text-sm leading-snug">
        {article?.title}
      </h4>
      <p className="text-xs text-gray-400">
        {truncateDescription(article?.description, len)}
      </p>
      <button
        className="text-sm text-black hover:text-orange-600 font-medium flex items-center gap-1 mt-auto justify-end pt-1 transition-colors"
        onClick={handleArticleClick}
      >
        See Article <ArrowRight />
      </button>
    </div>
  );
};
